import React from "react";
import "./Footer.css";
import { MdFacebook } from "react-icons/md";
import { FaLinkedinIn } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";
import { CgMail } from "react-icons/cg";

const Footer = () => {
  return (
    <footer className="footer__container">
      <div className="social__icons">
        <a
          className="social__icon"
          target="_blank"
          href="www.facebook.com/zobaerahmedzihad"
        >
          <MdFacebook />
        </a>
        <a
          className="social__icon"
          target="_blank."
          href="https://www.linkedin.com/in/zobaer-ahmed-zihad/"
        >
          <FaLinkedinIn />
        </a>
        <a
          className="social__icon"
          target="_blank."
          href="https://github.com/zobaerahmedzihad1"
        >
          <BsGithub />
        </a>
        <a
          className="social__icon"
          target="_blank."
          href="https://twitter.com/Zobaerahmedziha"
        >
          <FaTwitter />
        </a>
        <a
          className="social__icon"
          target="_blank."
          href="https://mail.google.com/mail/?view=cm&fs=1&to=zobaerahmedzihad01@gmail.com"
        >
          <CgMail />
        </a>
      </div>
      <div className="footer__content">
        <h6 className="footer__text">
          Designed and Developed by{" "}
          <a href="https://github.com/zobaerahmedzihad1" target="_blank.">
            <span style={{ color: "#DD1C63", cursor: "pointer" }}>
              Zobaer Ahmed Zihad
            </span>
          </a>
        </h6>
        <h6 className="footer__text">Copyright © 2022. All Rights Reserved</h6>
      </div>
    </footer>
  );
};

export default Footer;
